import React, { useEffect, useRef, useState } from 'react';
import { Send, MessageCircle } from 'lucide-react';
import { fmtDate } from '../../lib/orderMoney';

export const OrderChat = ({ messages, onSend, me, title = 'Messages', hint, testPrefix = 'order-chat' }) => {
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const endRef = useRef(null);
  useEffect(() => { endRef.current?.scrollIntoView({ block: 'nearest' }); }, [messages.length]);

  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setBusy(true); setErr('');
    try { await onSend(text.trim()); setText(''); }
    catch (ex) { setErr(ex?.response?.data?.detail || 'Message could not be sent'); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid={testPrefix} className="rounded-xl border border-neutral-200 dark:border-neutral-800 bg-white dark:bg-[#141416] flex flex-col">
      <div className="px-4 py-3 border-b border-neutral-100 dark:border-neutral-800 flex items-center gap-2">
        <MessageCircle size={15} className="text-brand" />
        <span className="text-[13.5px] font-semibold text-neutral-900 dark:text-neutral-100">{title}</span>
        {hint && <span className="text-[11.5px] text-neutral-500 ml-auto">{hint}</span>}
      </div>
      <div data-testid={`${testPrefix}-messages`} className="max-h-72 min-h-[110px] overflow-y-auto p-4 space-y-2.5">
        {messages.length === 0 && <div className="text-[12.5px] text-neutral-500 text-center py-6">No messages yet.</div>}
        {messages.map(m => {
          const mine = m.sender === me;
          return (
            <div key={m.id} className={`flex ${mine ? 'justify-end' : 'justify-start'}`}>
              <div className={`max-w-[80%] rounded-2xl px-3.5 py-2 text-[13px] leading-relaxed whitespace-pre-wrap break-words ${mine ? 'bg-brand text-white rounded-br-sm' : 'bg-neutral-100 dark:bg-neutral-800 text-neutral-900 dark:text-neutral-100 rounded-bl-sm'}`}>
                <div className={`text-[10.5px] mb-0.5 ${mine ? 'text-white/75' : 'text-neutral-500'}`}>{m.sender === 'admin' ? 'Healsglobe Exports' : 'Customer'} · {fmtDate(m.created_at)}</div>
                {m.text}
              </div>
            </div>
          );
        })}
        <div ref={endRef} />
      </div>
      <form onSubmit={send} className="p-3 border-t border-neutral-100 dark:border-neutral-800 flex gap-2">
        <textarea data-testid={`${testPrefix}-input`} rows={1} value={text} onChange={(e) => setText(e.target.value)} maxLength={2000}
          onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) send(e); }}
          placeholder="Write a message…" className="flex-1 resize-none bg-neutral-50 dark:bg-[#0f0f10] border border-neutral-200 dark:border-neutral-800 rounded-lg px-3 py-2 text-[13px] outline-none focus:border-brand" />
        <button data-testid={`${testPrefix}-send`} disabled={busy || !text.trim()} className="btn-brand rounded-lg px-3.5 inline-flex items-center gap-1.5 text-[13px] font-semibold disabled:opacity-50">
          <Send size={14} /> {busy ? '…' : 'Send'}
        </button>
      </form>
      {err && <div data-testid={`${testPrefix}-error`} className="px-4 pb-3 text-[12px] text-red-600">{err}</div>}
    </div>
  );
};
